var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#76C6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3105 8.86914C18.3105 9.27914 17.9805 9.61914 17.5605 9.61914H12.3105C11.9005 9.61914 11.5605 9.27914 11.5605 8.86914C11.5605 8.45914 11.9005 8.11914 12.3105 8.11914H17.5605C17.9805 8.11914 18.3105 8.45914 18.3105 8.86914Z",
    fill: "#023061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97055 7.90055L7.72055 10.1505C7.57055 10.3005 7.38055 10.3705 7.19055 10.3705C7.00055 10.3705 6.80055 10.3005 6.66055 10.1505L5.91055 9.40055C5.61055 9.11055 5.61055 8.63055 5.91055 8.34055C6.20055 8.05055 6.67055 8.05055 6.97055 8.34055L7.19055 8.56055L8.91055 6.84055C9.20055 6.55055 9.67055 6.55055 9.97055 6.84055C10.2605 7.13055 10.2605 7.61055 9.97055 7.90055Z",
    fill: "#023061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3105 15.8691C18.3105 16.2791 17.9805 16.6191 17.5605 16.6191H12.3105C11.9005 16.6191 11.5605 16.2791 11.5605 15.8691C11.5605 15.4591 11.9005 15.1191 12.3105 15.1191H17.5605C17.9805 15.1191 18.3105 15.4591 18.3105 15.8691Z",
    fill: "#023061"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97055 14.9005L7.72055 17.1505C7.57055 17.3005 7.38055 17.3705 7.19055 17.3705C7.00055 17.3705 6.80055 17.3005 6.66055 17.1505L5.91055 16.4005C5.61055 16.1105 5.61055 15.6305 5.91055 15.3405C6.20055 15.0505 6.67055 15.0505 6.97055 15.3405L7.19055 15.5605L8.91055 13.8405C9.20055 13.5505 9.67055 13.5505 9.97055 13.8405C10.2605 14.1305 10.2605 14.6105 9.97055 14.9005Z",
    fill: "#023061"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/consultant.37e51f0e4dd0a7182b9da89f558cec29.svg";
export { ForwardRef as ReactComponent };